module.exports = __webpack_public_path__ + "img/beijing01.a6916683.png";